﻿(function ($) {
   
  $(document).ready(function () {

      $('.js-campaign-form-container').each(function (index, element) {
        var $form = $(element);

        RegisterEvents($form);

        ////reset form on initial page load
        ResetForm($form, true);

        //Temporary fix to initially hide the Company field
        ToggleFieldVisibility($form, 'CompanyName', IsFP($form), null);

        ////we hide the form until all rules are processed. This eliminates any visible aesthetic adjustments, aka flickering.
        $form.removeClass('hidden');
      });

    });

  function IsFP($form) {
    if ($form.length) {
      if ($form.find('select.InvestorType').length) {
                var investorType = $form.find('select.InvestorType').val();
                return investorType != null && investorType !== 'Individual Investor';
            }
        }
        return false;
    }

  function RegisterEvents($form) {
        $form.find('input[type=checkbox]').change(function (event) {
            var value = $(this).is(":checked");
            $(this).val(value);
        });

        $form.find('#chkSetupCall').change(function (event) {
            var id = 'SetupCallRequestReason';
            var setupCallIsChecked = $(this).is(":checked");

          ToggleFieldVisibility($form, id, setupCallIsChecked, this.id);

            if (setupCallIsChecked)
                $(id).focus();

            $form.find('#SetupCall').val(setupCallIsChecked ? 'Yes' : 'No');
        });

        $form.find("input.Email").blur(function (event) {
            //pouplate the MunchkinTokenListJSON field when munchkin is loaded before this js file
            GetMunchkinTokenListJSON();
        });

        $form.find('select.InvestorType').change(function (event) {
            var investorType = $(this).val();

            switch (investorType) {
                case '(Select)':
                case 'Individual Investor':
                    //$('#chkSetupCall').prop('checked', false);
                ToggleFieldVisibility($form, 'CompanyName', false, this.id);

                    break;

                default: //FP
                    //If rules exist then use rules else true for FP         
                ToggleFieldVisibility($form, 'CompanyName', true, this.id);
            }
        });

        function AppendTo() {
            var isEmptyList = "";
            $('[data-append-to-id]').each(function () {
                var destinationId = $(this).data('append-to-id');
                var $destination = $('#' + destinationId);
                var $source = $(this).find(":input:visible[type!='radio']");

                if ($source.length === 0) {
                    $source = $(this).find(":input:visible[type='radio']:checked");
                }
                var value = $source.val();
                var name = $source.prop('name');

                if (!isEmptyOrSpaces(value)) {
                    var key = '[' + destinationId + ']'
                    if (!isEmptyList.includes(key)) {
                        isEmptyList += key;
                        $destination.val("");
                    }
                    var destinationValue = $destination.val();
                    if (!isEmptyOrSpaces(destinationValue)) {
                        destinationValue += '|'
                    }
                    $destination.val(destinationValue + name + ':' + value);
                }
            });
        }

        $form.find('#Country').change(function () {
            var country = $(this).val();

          ToggleFieldVisibility($form, 'State,ddlUSStates,ddlCAStates', false, this.id);

            switch (country.toLowerCase()) {
                case "us":
                ToggleFieldVisibility($form, 'ddlUSStates', true, this.id);
                    break;
                case "ca":
                ToggleFieldVisibility($form, 'ddlCAStates', true, this.id);
                    break;
                default:
                ToggleFieldVisibility($form, 'State', true, this.id);
            }
        });

        $form.find('[id ^=ddl][id $=States]').change(function () {
            var $select = $(this);

            $('#State').val($select.val());
        });

        $('form input[type=submit]').click(function () {
            AppendTo();
        });

        if (typeof vaneck !== "undefined") {
            vaneck.membership.initializeSpinner();
        }

        if (typeof $$epiforms !== "undefined") {
            $$epiforms('.js-aspnet-form').on('formsSubmitted',
                function(event) {
                    if (event.returnedResult != null && event.returnedResult.AdditionalParams != null) {
                        var downloadedFile = event.returnedResult.AdditionalParams["DownloadFilePath"];
                        if (downloadedFile != null) {
                            downloadURI(downloadedFile, "");
                        }
                    }
                });
        }

        function downloadURI(uri, name) {
            var link = document.createElement("a");
            link.setAttribute('download', name);
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
  }

    function GetMunchkinTokenListJSON() {
        var $input = $('#MunchkinTokenListJSON');
        var munchkinCookie = $.cookie("_mkto_trk");

        if (munchkinCookie != '') {
            //http://www.epochconverter.com
            var epochTime = Math.round((new Date).getTime() / 1000);

            var munchkinTokenListJSON = [{
                "cookie": munchkinCookie,
                "timestamp": epochTime
            }];

            var jsonString = JSON.stringify(munchkinTokenListJSON);

            $input.val(jsonString);
        }
    };

  function GetFieldset($form, id) {
        return $form.find('.fieldset:has(.' + id + ')');
    }

  function ResetForm($form, force) {
      var form = $form.parents('form')[0];
      if (form) {
          //capture email
          var email = $form.find('input.Email').val();

          //reset form
          form.reset();

          if (typeof force === 'undefined')
          //replace email
            $form.find('input.Email').val(email);

          //fire change event to reset dependencies
          $form.find('select:visible').change();
        }
    }
    
  function ToggleFieldVisibility($form, ids, isVisible, requesterId) {
        ids = ids.split(',');

        ids.forEach(function (id) {
          var $fieldset = GetFieldset($form, id);
            var $control = $('.' + id);
            var dependsOn = $fieldset.data('depends-on');

            if (isVisible === false || typeof dependsOn === 'undefined' || dependsOn === requesterId) {
               
                if (isVisible) {
                    $fieldset.show();
                    $control.show();
                } else {
                    ResetField($form, id);
                    $fieldset.hide();
                    $control.hide();
                }
            } else {
                isVisible = false;
            }
        });

        return isVisible;
    }

  function ResetField($form, id) {
    var $fieldset = GetFieldset($form, id);

        $fieldset.find('.field-input input.' + id).each(function () {
            $(this).val(function () {
                return this.defaultValue;
            });
        });

        $fieldset.find('.field-input select.' + id).each(function () {
            $(this).val($(this).find("option:first").attr("selected", true).val());
        });


    }
})(jQuery);

